<template>
  <div class="container">
    <div class="background">
      <Info :userInfo="userInfo" :show="show"/>
      <Order />
    </div>
    <Tools />
    <Recommend />
    <tabbar></tabbar>
  </div>
</template>

<script>
import wx from 'weixin-jsapi'
import {getSignature1} from '@/api/login/wx'
import Info from './modules/Info'
import Order from './modules/Order'
import Tools from './modules/Tools'
import Recommend from './modules/Recommend'
import clientLogin from '../../views/login/clientLogin'
import {getCurtUser} from '@/api/login'
export default {
  name: 'Mine',
  components: {
    Info,
    Order,
    Tools,
    Recommend,
    clientLogin
  },
  data () {
    return {
      show: false,
      userInfo: {},
      token: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == 'clientLogin') {
        vm.show = true
      }
    })
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // XXX: 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    localStorage.setItem("scrollMine", document.querySelector(".container").scrollTop)
    next()
  },
  activated:function() {
    this.$nextTick(() => {
      document.querySelector(".container").scrollTop = localStorage.getItem("scrollMine")
      localStorage.setItem("scrollMine", 0)
    })

  },
  created () {

  },
  mounted () {
    const tokenStr = window.localStorage.getItem('Authorization')
    this.token = tokenStr
    this.init();
  },

  methods: {
    init(){
      var url = location.href;
      getSignature1({url: url}).then(response=>{
        if(response.success){
          wx.config({
            debug: false,
            appId: response.data.appId,
            timestamp: response.data.timestamp,
            nonceStr: response.data.nonceStr,
            signature: response.data.signature,
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
          });
        }else{
          //alert(response.msg);
        }
        this.share();
      })
    },
    share(){
      // 微信分享配置
      var that = this
      let user = localStorage.getItem("userInfo");
      if (user){
        user = JSON.parse(user);
      }
      wx.ready(function () {
        // 分享给好友
        wx.onMenuShareAppMessage({
          title: '创客芯城', // 分享标题
          desc: "http://ckaicai.com/api/system/wx/login?pid=" + user.code, // 分享描述
          link: "http://ckaicai.com/api/system/wx/login?pid=" + user.code, // 分享链接
          //imgUrl: '', // 分享图标
          success: function(res) {
            that.$toast.success('分享成功');
          },
          fail: function (res) {

          }
        })
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          title: '创客芯城', // 分享标题
          desc: "http://ckaicai.com/api/system/wx/login?pid=" + user.code, // 分享描述
          link: "http://ckaicai.com/api/system/wx/login?pid=" + user.code, // 分享链接
          //imgUrl: '', // 分享图标
          success:function(res){
            that.$toast.success('分享成功');
          },
          fail:function(res){

          }
        })
        //alert('请点击右上角分享按钮！');
      });
      wx.error(function (res) {
        //alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
      });
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
  padding-bottom: 50px;
  padding-top: 0px;
  font-size: 14px;
  background-color: #ededed;
  .background {
    background-color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mine/index.vue